export const TableIcon: React.FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="16" rx="1.5" />
    <line x1="3" y1="9.5" x2="21" y2="9.5" />
    <line x1="9" y1="9.5" x2="9" y2="20" />
  </svg>
);
